module.exports = __webpack_public_path__ + "img/pic_1.76994860.jpg";